import { FlowBaseInfo } from '../models/FlowInfo';
import { IErrorItem } from '../models/MultipleItemResult';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { Flows } from '../resources/Flows';
import { IResult } from '../ServerApi/types/IResponse';
import { FlowErrors } from '../services/FlowErrors';
import { ActionHelpers } from './ActionHelpers';

export class ChangeFlowDescriptionAction {

  public static $inject = ['ActionHelpers', 'Flows', 'FlowErrors'];

  constructor(
    private ActionHelpers: ActionHelpers,
    private Flows: Flows,
    private FlowErrors: FlowErrors
  ) { }

  public execute(flow: FlowBaseInfo, newDescription: string): ng.IPromise<IResult> {

    return this.Flows.setDescription(flow.id, newDescription).then((result: IResult) => {
        this.ActionHelpers.notifyStandardError(
          Set.singletonForIdItem(flow),
          { successId: 'editDescriptionSuccessful', errorId: 'editDescriptionFailure' },
          (errorItem: IErrorItem<FlowBaseInfo>) => this.FlowErrors.errorDetailsFor(errorItem)
        )(result);
        return result;
    });
  }
}

Module.instance().service('ChangeFlowDescriptionAction', ChangeFlowDescriptionAction);
